var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "17px",
    viewBox: "0 0 15 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Projects",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DG-TieOut-|-Project-Cards-|-Default-w-suport-access-hover",
    transform: "translate(-24.000000, -250.000000)",
    fill: "#86BC25",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage/-Project-Panel-/-Default",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-/-Project-Card-/-Default",
    transform: "translate(0.000000, 174.527197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Card-/-Selected"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Support-Access",
    transform: "translate(24.000000, 27.765690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8858954,1.63204211 C14.8631776,1.44287659 14.746856,1.27788885 14.5762168,1.19275585 C14.4047236,1.10745259 14.2028261,1.11256057 14.0374821,1.20961218 C14.0050282,1.22851171 10.7758649,3.02975565 7.90198651,0.165881644 C7.6799335,-0.0552938814 7.32020762,-0.0552938814 7.09815461,0.165881644 C4.24204044,3.01272905 1.09401197,1.28282656 0.962659069,1.20961218 C0.79714417,1.11426323 0.595417549,1.10745259 0.423924299,1.19275585 C0.2532851,1.27788885 0.136963484,1.44287659 0.114074942,1.63204211 C-1.05580281,11.4119505 7.1560592,15.760544 7.23907287,15.8031105 C7.26401113,15.8150291 7.28997425,15.82201 7.31559575,15.830353 C7.32960217,15.8356313 7.34275454,15.8424419 7.35727339,15.845677 C7.40441696,15.8575956 7.45207295,15.8661089 7.49938732,15.8661089 L7.50058299,15.8661089 C7.54806817,15.8661089 7.59572417,15.8575956 7.64269692,15.845677 C7.65806982,15.8424419 7.67207624,15.8356313 7.68693671,15.830353 C7.71170416,15.82201 7.73698405,15.8150291 7.76089745,15.8031105 C7.84391111,15.760544 16.0559439,11.4119505 14.8858954,1.63204211 Z M12.3480003,2.86459773 L3.83568343,11.3506551 C3.6594075,11.1242014 3.4853521,10.8875316 3.31590857,10.6389433 L11.0881056,2.89013763 C11.5359695,2.92589349 11.9594075,2.91227221 12.3480003,2.86459773 Z M1.17155971,2.52406565 C2.43692026,2.9684599 5.04894693,3.46052862 7.49989975,1.33560901 C8.24873083,1.98602511 9.01122672,2.38955552 9.74707624,2.62452259 L2.7037255,9.64629222 C1.68194002,7.80401416 0.97051633,5.44412747 1.17155971,2.52406565 Z",
    id: "shield"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.dcd62689d1d248bbb5e225bf73ebf437.svg";
export { ForwardRef as ReactComponent };